import { Button, CircularProgress } from '@mui/material';
import React from 'react';

interface Props extends Omit<Parameters<typeof Button>[0], 'loading'> {
  readonly loading?: boolean;
}

export const LoadingButton: React.FC<React.PropsWithChildren<Props>> = (
  props: Props,
): React.ReactElement => {
  const {
    loading = false,
    disabled,
    startIcon,
    variant,
    size,
    color,
    fullWidth,
    sx,
    children,
    ...restProps
  } = props;

  const computedStartIcon = React.useMemo(
    (): React.ReactNode =>
      loading ? <CircularProgress size={20} thickness={7} color="inherit" /> : startIcon,
    [loading, startIcon],
  );

  const computedDisabled = React.useMemo((): boolean => disabled || loading, [disabled, loading]);

  return (
    <Button
      {...restProps}
      disabled={computedDisabled}
      variant={variant}
      size={size}
      color={color}
      fullWidth={fullWidth}
      sx={sx}
      startIcon={computedStartIcon}>
      {children}
    </Button>
  );
};
